<template>
  <div>
    <MapStaffCard :staffMo="staffMo" />
    <MasterLayout>
      <div class="pt-5 pb-3 pl-4 pr-3 dashboard_first_row">
        <div class="row">
          <div class="col-md-8">
            <div class="py-5 pt-5 mb-3 row align-items-center white-bg">
              <div class="col-md-1 remove-right-padding col-center-flex">
                <div class="square-icon-wrapper small sky-bg">
                  <img src="@/assets/img/id-card.png" width="35" />
                </div>
              </div>
              <div class="py-1 col-md-6">
                <h4 class="primary-color font-600">
                  {{ $t("text.staff.title") }}
                </h4>
                <p class="mt-3 light-grey-text">
                  {{ $t("text.staff.description") }}
                </p>
              </div>
              <div class="col-md-5 flexify">
                <router-link
                  :to="{
                    name: 'new_staff',
                    query: {
                      companyId: $route.query.companyId,
                      branchId: this.branchId,
                      dealerId: $route.query.dealerId,
                      groupId: $route.query.groupId,
                      regionId: $route.query.regionId,
                    },
                  }"
                  class="btn btn-warning"
                  >{{ $t("text.staff.addNew") }}
                  <!-- <img src="@/assets/img/paper-plane.png"  width="30px" class="ml-3" /> -->
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="py-4 card_container">
              <div class="card__header___text">
                <div>
                  <h3 class="text-center our_branches__header">
                    {{ $t("text.staff.totalStaffs") }}
                  </h3>
                  <div class="mt-3 dealer__icon__wrapper">
                    <div class="text-center dealer__icon__div">
                      <div>
                        <img src="@/assets/img/id-card.png" width="35" />
                      </div>
                    </div>
                  </div>
                  <h3 class="mt-2 text-center our_branches__header">
                    {{ staffsCount }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="row card-loader-wrapper w-100 mt-5" v-if="showLoader">
        <div class="col-md-3 position-relative" v-for="(c, i) in 4" :key="i">
          <div class="card-loader"></div>
        </div>
      </section>
      <div
        class="staff-container mt-3"
        style="margin: 0 auto; width: 99.6%"
        v-if="!showLoader"
      >
        <div class="row">
          <div
            class="col-md-3 nopadright mb-3 mr-3"
            v-for="(staff, i) in staffs"
            :key="i"
          >
            <div class="staff" style="height: 311px">
              <h3 class="tank__name text-center mt-3">
                {{ staff.firstName }} {{ staff.lastName }}
              </h3>
              <div class="dealer__icon__wrapper mt-3">
                <div class="dealer__icon__div text-center">
                  <div>
                    <img src="@/assets/img/employee.svg" width="35px" />
                  </div>
                </div>
              </div>
              <div class="fuelcard">
                <div class="left">
                  <span class="lightspan">{{ $t("text.form.name") }}:</span>
                </div>
                <div class="right">
                  <span class="boldspan"
                    >{{ staff.firstName }} {{ staff.lastName }}</span
                  >
                </div>
              </div>
              <div class="fuelcard">
                <div class="left">
                  <span class="lightspan">{{ $t("text.staff.gender") }}:</span>
                </div>
                <div class="right">
                  <span class="boldspan">{{ staff.gender }}</span>
                </div>
              </div>
              <div class="fuelcard" style="padding-bottom: 15px">
                <div class="text-center pb-3">
                  <div class="btn-group btn-group-sm" role="group">
                    <router-link
                      :to="{
                        path: `/Retail-Outlet/staff-details/${staff.id}`,
                        query: $route.query.branchId
                          ? {
                              id: staff.id,
                              branchId: branchId,
                              companyId: $route.query.companyId,
                            }
                          : { id: staff.id, companyId: $route.query.companyId },
                      }"
                      class="btn btn-warning"
                      title="View Staff"
                    >
                      <i class="fa fa-eye mr-1" aria-hidden="true"></i>
                      {{ $t("text.staff.view") }}
                    </router-link>

                    <router-link
                      :to="{
                        path: `/Retail-Outlet/edit-staff/${staff.id}`,
                        query: $route.query.branchId
                          ? {
                              id: staff.id,
                              branchId: branchId,
                              companyId: $route.query.companyId,
                            }
                          : { id: staff.id, companyId: $route.query.companyId },
                      }"
                      class="btn btn-primary"
                      title="Edit Staff"
                    >
                      <i class="fa fa-edit mr-1" aria-hidden="true"></i>
                      {{ $t("text.staff.edit") }}
                    </router-link>
                    <router-link
                      :to="{
                        path: `/Retail-Outlet/Ratings/${staff.id}/${staff.firstName} ${staff.lastName}`,
                        query: $route.query.branchId
                          ? {
                              id: staff.id,
                              branchId: branchId,
                              companyId: $route.query.companyId,
                            }
                          : { id: staff.id, companyId: $route.query.companyId },
                      }"
                      class="btn btn-info"
                      title="View staff ratings"
                    >
                      <i class="fa fa-star-half-o mr-1" aria-hidden="true"></i>
                      {{ $t("text.general.rating") }}
                    </router-link>
                    <button
                      v-if="!staff.cardId"
                      @click="mapCard(staff)"
                      class="btn btn-success"
                      :title="$t('text.staff.mapCard')"
                    >
                      <i class="fa fa-id-card-o mr-1" aria-hidden="true"></i>
                      {{ $t("text.staff.mapCard") }}
                    </button>
                    <button
                      v-else
                      @click="unmapCard(staff)"
                      class="btn btn-dark"
                      :title="$t('text.staff.unMapCard')"
                    >
                      <i class="fa fa-id-card-o mr-1" aria-hidden="true"></i>

                      {{ $t("text.staff.unMapCard") }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-danger"
                      title="Delete"
                      @click="deleteStaff(staff.id)"
                    >
                      <i class="fa fa-trash-o mr-1" aria-hidden="true"></i>
                      {{ $t("text.staff.delete") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import backgroundUrl from "@/assets/img/BecomeDealer.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import MapStaffCard from "@/components/modals/staffs/mapStaffCard.vue";
import configObject from "@/config";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";

export default {
  name: "OurBranches",
  components: {
    MasterLayout,
    MapStaffCard,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      branches: [],
      dealerId: null,
      backgroundUrl,
      cardBackgroundUrl,
      showLoader: true,
      branchCount: 0,
      company: localStorage.getItem("companyDetails")
        ? JSON.parse(localStorage.getItem("companyDetails"))
        : null,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      staffs: [],
      staffsCount: 0,
      branch: {},
      branchId: null,
      staffMo: {},
    };
  },
  created() {
    document.title = "Staff:: Epump Retail Outlet";
    if (localStorage.getItem("userDetails") === "null") {
      this.$router.push({ path: "/" });
    } else if (configObject.authConfig() === null) {
      window.location.reload();
    }
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Staff:: ${branch.name} Retail Outlet`;
    });
    this.$eventHub.$on("refreshStaffTable", () => {
      // console.log("event trigered");
      this.getStaffs();
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("refreshStaffTable");
  },
  watch: {
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = this.branch.id;
      }
      if (this.branchId !== null) {
        this.getStaffs();

        $(".e-input").keyup(function (e) {
          searchFun(e);
        });
        function searchFun(event) {
          var grid =
            document.getElementsByClassName("e-grid")[0].ej2_instances[0];
          var value = event.target.value;
          grid.search(value);
        }
      }
    },
  },
  mounted() {},
  methods: {
    mapCard(staff) {
      // console.log("map card activated");
      this.staffMo = staff;
      this.$modal.show("mapStaffCardModal");
    },
    unmapCard(staff) {
      const remove = confirm(this.$t("text.errors.sureWantUnmap"));
      if (!remove) {
        return;
      }
      const data = {
        staffId: staff.id,
        cardId: staff.cardId,
      };

      this.axios
        .post(
          `${configObject.apiBaseUrl}/staff/unmapLogCard`,
          data,
          configObject.authConfig()
        )
        .then((res) => {
          this.getStaffs();
          this.$toast.open({
            message: this.$t("text.cUsers.mapSuccess"),
            type: "success",
            duration: 4000,
          });
        })
        .catch((error) => {
          this.$toast.open({
            message: this.$t("text.requests.failure"),
            type: "error",
            duration: 4000,
          });
        });
    },
    openEditStaff(staff) {
      let staffDetail = this.staffs.filter((stf) => stf.id === staff.id)[0];
      this.staff = staffDetail;
      this.$eventHub.$emit("editStaff", staffDetail);
      this.$router.push({
        name: "edit_staff",
        query: {
          companyId: this.$route.query.companyId,
          dealerId: this.$route.query.dealerId,
          groupId: this.$route.query.groupId,
          regionId: this.$route.query.regionId,
        },
      });
    },
    openStaffEditModal() {
      this.$modal.show("editStaff");
    },
    deleteStaff(id) {
      const remove = confirm(this.$t("text.staff.confirmDelete"));
      if (!remove) {
        return;
      }
      const data = { staffId: id };
      let formData = JSON.stringify(data);
      fetch(`${configObject.apiBaseUrl}/Staff`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: configObject.authConfig().headers.Authorization,
        },
        body: JSON.stringify(data),
      })
        .then((res) => {
          this.getStaffs();
          this.$toast.open({
            message: this.$t("text.staff.successfullyDeleted"),
            type: "success",
            duration: 4000,
          });
        })
        .catch((error) => {
          this.$toast.open({
            message: this.$t("text.staff.unsuccessfulDelete"),
            type: "error",
            duration: 4000,
          });
        });
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    changeRoute(routeName, id) {
      this.$router.push({
        name: routeName,
        query: this.$route.query.branchId
          ? { id: id, branchId: this.branchId }
          : { id: id },
      });
    },
    getStaffs() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Staff/BranchStaff/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          this.staffs = response.data;
          this.staffsCount = response.data.length;
          this.$eventHub.$emit("staffs", this.staffs);
        })
        .catch((error) => {});
    },
  },
};
</script>
